<template>
  <div></div>
</template>
<script>
import router from "@/router";
export default {
  name: "login",
  data: {},
  created() {
    localStorage.removeItem("params");
    const url = window.location.href;
    // 项管登录
    if (url.indexOf("token") > -1) {
      const token = url.match(/token=(\S*)&menu=/)[1];
      let menuIndex = -1;
      let paramsIndex = -1;
      let params = null;
      let page = null;
      if (url.indexOf("&params=") > -1) {
        //url 带params （项目周报）
        paramsIndex = url.indexOf("&params=");
        params = decodeURIComponent(url.substr(paramsIndex + 8, url.length));
        localStorage.setItem("params", params);
        page = decodeURIComponent(url.match(/&menu=(\S*)&params=/)[1]);
      } else {
        //url 不带params（it服务周报）
        menuIndex = url.indexOf("&menu=");
        page = decodeURIComponent(url.substr(menuIndex + 6, url.length));
      }
      localStorage.setItem("token", token);
      location.href = page;
      this.$store.dispatch("common/fetchUserInfoAction");
    }
    //课题系统
    else {
      const q = this.$route.query;
      // const q = "http://localhost:1314/#/pmpIdex?bh=10958&tk=KWSXMTExMTExzTsw";
      const from = q.tk
        ? {
            password: q.tk,
            username: q.bh,
          }
        : null;
      document.title = "课题系统";
      //测试生产登录

      this.$store.dispatch("common/loginAction", from).then((res) => {
        if (res.code == 0) {
          localStorage.setItem("token", res.token);
          router.push("/course/index");
        }
      });
    }

    // var link =
    //   document.querySelector("link[rel*='icon']") ||
    //   document.createElement("link");

    // link.type = "image/x-icon";

    // link.rel = "shortcut icon";

    // link.href = faviconurl;

    // document.getElementsByTagName("head")[0].appendChild(link);

    // if (window.href =  > -1) {
    //   router.push("/weekly");
    // }
  },
};
</script>
